// fixed_header: each panel pins a channel band (PanelPlaceBar) over its 46px
// header spacer, and the floating scroll-to-top pill opens below it.

// The panel's header (PanelPlaceBar), rendered beside its scroll container.
export const PLACE_BAR_SELECTOR = '[data-testid="panel-place-bar"]'

// It is on for everyone. The check stays the one place that asks, so the
// floating header controls it replaces can be taken out behind it.
export function fixedHeaderEnabled(): boolean {
    return true
}
